import React from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * Set of translations to be reused throughout the interface instead of repeatedly having the same words translated
 */

export const cancelText = (
  <FormattedMessage
    id="shared.cancelText"
    defaultMessage="Cancel"
    description="Cancels an action"
  />
);

export const clearText = (
  <FormattedMessage
    id="shared.clearText"
    defaultMessage="Clear"
    description="Clears something"
  />
);

export const submitText = (
  <FormattedMessage
    id="shared.submitText"
    defaultMessage="Submit"
    description="Submits a form or action"
  />
);
export const editText = (
  <FormattedMessage
    id="shared.editText"
    defaultMessage="Edit"
    description="Opens editing something"
  />
);
export const titleText = (
  <FormattedMessage
    id="shared.titleText"
    defaultMessage="Title"
    description="Opens editing something"
  />
);

export const resetText = (
  <FormattedMessage
    id="shared.resetText"
    defaultMessage="Reset"
    description="Reset the form"
  />
);

export const noneSelectedText = (
  <FormattedMessage
    id="shared.noneSelectedText"
    defaultMessage="None Selected"
    description="Nothing has been selected"
  />
);

export const emptyText = (
  <FormattedMessage
    id="shared.emptyText"
    defaultMessage="(empty)"
    description="Nothing has been selected"
  />
);

export const nameText = (
  <FormattedMessage
    id="shared.nameText"
    defaultMessage="Name"
    description="The name of the item being displayed"
  />
);
export const idText = (
  <FormattedMessage
    id="shared.idText"
    defaultMessage="ID"
    description="The id of the item being displayed"
  />
);
export const unitText = (
  <FormattedMessage
    id="shared.unitText"
    defaultMessage="Unit"
    description="A unit"
  />
);
export const unitsText = (
  <FormattedMessage
    id="shared.unitsText"
    defaultMessage="Units"
    description="A number of units"
  />
);
export const activeUnitText = (
  <FormattedMessage
    id="shared.activeUnitText"
    defaultMessage="Active Unit"
    description="A number of units"
  />
);

export const unitNameText = (
  <FormattedMessage
    id="shared.unitNameText"
    defaultMessage="Unit Name"
    description="The name of the unit"
  />
);

export const userText = (
  <FormattedMessage
    id="shared.userText"
    defaultMessage="User"
    description="A user"
  />
);
export const searchText = (
  <FormattedMessage
    id="shared.searchText"
    defaultMessage="Search"
    description="Serach for something"
  />
);

export const firstNameText = (
  <FormattedMessage
    id="shared.firstNameText"
    defaultMessage="First Name"
    description="The first name of a user"
  />
);

export const lastNameText = (
  <FormattedMessage
    id="shared.lastNameText"
    defaultMessage="Last Name"
    description="The last name of a user"
  />
);

export const usernameText = (
  <FormattedMessage
    id="shared.usernameText"
    defaultMessage="Username"
    description="The users username"
  />
);

export const middleNameText = (
  <FormattedMessage
    id="shared.middleNameText"
    defaultMessage="Middle Name"
    description="The middle name of a user"
  />
);

export const archiveText = (
  <FormattedMessage
    id="shared.archiveText"
    defaultMessage="Archive"
    description="Label for archiving an item"
  />
);

export const viewDetailsText = (
  <FormattedMessage
    id="shared.viewDetailsText"
    defaultMessage="View Details"
    description="A link to view more details about an item"
  />
);

export const deviceText = (
  <FormattedMessage
    id="shared.deviceText"
    defaultMessage="Device"
    description="A device"
  />
);
export const devicesText = (
  <FormattedMessage
    id="shared.devicesText"
    defaultMessage="Devices"
    description="A number of devices"
  />
);
export const groupText = (
  <FormattedMessage
    id="shared.groupText"
    defaultMessage="Group"
    description="A group"
  />
);
export const groupsText = (
  <FormattedMessage
    id="shared.groupsText"
    defaultMessage="Groups"
    description="A number of groups"
  />
);

export const archiveChallengeText = (
  <FormattedMessage
    id="shared.archiveChallengeText"
    defaultMessage="Are you sure you want to archive"
    description="Text to check if a user wants to archive an item"
  />
);

export const unArchiveChallengeText = (
  <FormattedMessage
    id="shared.unArchiveChallengeText"
    defaultMessage="Are you sure you want to unarchive"
    description="Text to check if a user wants to unarchive an item"
  />
);

export const noStatusText = (
  <FormattedMessage
    id="shared.noStatusText"
    defaultMessage="No Status"
    description="There is no status available for the item"
  />
);

export const archivedText = (
  <FormattedMessage
    id="shared.archivedText"
    defaultMessage="Archived"
    description="The user is an archived user"
  />
);

export const sortOrderText = (
  <FormattedMessage
    id="shared.sortOrderText"
    defaultMessage="Sort Order"
    description="The order of sorting the users"
  />
);

export const newUnitText = (
  <FormattedMessage
    id="shared.newUnitText"
    defaultMessage="New unit"
    description="The first part of the sentence 'New unit: 'Room 101' was/was not created'"
  />
);
export const newUserText = (
  <FormattedMessage
    id="shared.newUserText"
    defaultMessage="New user"
    description="The first part of the sentence 'New user: 'Room 101' was/was not created'"
  />
);

export const unArchiveText = (
  <FormattedMessage
    id="shared.unArchiveText"
    defaultMessage="Unarchive"
    description="Label for unarchiving an item"
  />
);

export const wasNotCreatedText = (
  <FormattedMessage
    id="shared.wasNotCreatedText"
    defaultMessage="was not created."
    description="The last part of the sentence 'New unit: 'Room 101' was not created'"
  />
);
export const wasCreatedText = (
  <FormattedMessage
    id="shared.wasCreatedText"
    defaultMessage="was created."
    description="The last part of the sentence 'New unit: 'Room 101' was created'"
  />
);
export const wasUpdatedText = (
  <FormattedMessage
    id="shared.wasUpdatedText"
    defaultMessage="was updated."
    description="The last part of the sentence 'Unit: 'Room 101' was updated'"
  />
);
export const wasArchivedText = (
  <FormattedMessage
    id="shared.wasArchivedText"
    defaultMessage="was archived."
    description="The last part of the sentence 'Unit: 'Room 101' was archived'"
  />
);
export const wasUnArchivedText = (
  <FormattedMessage
    id="shared.wasUnArchivedText"
    defaultMessage="was unarchived."
    description="The last part of the sentence 'Unit: 'Room 101' was unarchived'"
  />
);
export const wasNotUpdatedText = (
  <FormattedMessage
    id="shared.wasNotUpdatedText"
    defaultMessage="was not updated."
    description="The last part of the sentence 'Unit: 'Room 101' was not updated'"
  />
);
export const wasNotArchivedText = (
  <FormattedMessage
    id="shared.wasNotArchivedText"
    defaultMessage="was not archived."
    description="The last part of the sentence 'Unit: 'Room 101' was not archived'"
  />
);

export const descriptionText = (
  <FormattedMessage
    id="shared.descriptionText"
    defaultMessage="Description"
    description="The description for the item"
  />
);
export const batteryStatusText = (
  <FormattedMessage
    id="shared.batteryStatusText"
    defaultMessage="Battery Status"
    description="The status of the battery"
  />
);

export const batteryHelpText = (
  <FormattedMessage
    id="shared.batteryHelpText"
    defaultMessage="The battery for this device is healthy."
    description="Help text for understanding what the low battery icon means"
  />
);

export const batteryLowHelpText = (
  <FormattedMessage
    id="shared.batteryLowHelpText"
    defaultMessage="The battery level is low for this device."
    description="Help text for understanding what the low battery icon means"
  />
);

export const selectedUsersText = (
  <FormattedMessage
    id="shared.selectedUsersText"
    defaultMessage="Selected Users:"
    description="The parent unit of the unit being created"
  />
);

export const selectedUnitsText = (
  <FormattedMessage
    id="shared.selectedUnitsText"
    defaultMessage="Selected Units:"
    description="The parent unit of the unit being created"
  />
);

export const selectedDevicesText = (
  <FormattedMessage
    id="shared.selectedDevicesText"
    defaultMessage="Selected Devices:"
    description="The parent unit of the unit being created"
  />
);

export const quickEditAlarmDevicesText = (
  <FormattedMessage
    id="shared.quickEditAlarmDevicesText"
    defaultMessage="Quick Edit Monitored Devices"
    description="A link to open the interface to edit the devices assigned to this unit"
  />
);

export const quickEditAlertDevicesText = (
  <FormattedMessage
    id="shared.quickEditAlertDevicesText"
    defaultMessage="Quick Edit Alert Devices"
    description="A link to open the interface to edit the devices assigned to this unit"
  />
);
export const typeText = (
  <FormattedMessage
    id="shared.typeText"
    defaultMessage="Type"
    description="The type of the item"
  />
);
export const categoryText = (
  <FormattedMessage
    id="shared.categoryText"
    defaultMessage="Category"
    description="The category of the item"
  />
);
export const associateAlarmDeviceText = (
  <FormattedMessage
    id="shared.associateAlarmDeviceText"
    defaultMessage="Associate Monitored Device"
    description="The type of the item"
  />
);
export const associateAlertDeviceText = (
  <FormattedMessage
    id="shared.associateAlertDeviceText"
    defaultMessage="Associate Alert Device"
    description="The type of the item"
  />
);
export const phoneText = (
  <FormattedMessage
    id="shared.phoneText"
    defaultMessage="Phone Number"
    description="The type of the item"
  />
);

 
export const massnotificationText = (
  <FormattedMessage
    id="shared.massnotificationText"
    defaultMessage="Mass Notification Contact"
    description="The type of the item"
  />
);



export const emailText = (
  <FormattedMessage
    id="shared.emailText"
    defaultMessage="Email Address"
    description="The type of the item"
  />
);
export const shortMsgText = (
  <FormattedMessage
    id="shared.shortMsgText"
    defaultMessage="Short Message Format"
    description="The type of the item"
  />
);
export const interfaceText = (
  <FormattedMessage
    id="shared.interfaceText"
    defaultMessage="Interface"
    description="The type of the item"
  />
);
export const deviceDescriptionText = (
  <FormattedMessage
    id="shared.deviceDescriptionText"
    defaultMessage="Device Description"
    description="The type of the item"
  />
);
export const deviceIdText = (
  <FormattedMessage
    id="shared.deviceIdText"
    defaultMessage="Device Id"
    description="The type of the item"
  />
);
export const closeText = (
  <FormattedMessage
    id="shared.closeText"
    defaultMessage="Close"
    description="The type of the item"
  />
);
export const notesText = (
  <FormattedMessage
    id="shared.notesText"
    defaultMessage="Notes"
    description="The type of the item"
  />
);
export const wasNotLoadedText = (
  <FormattedMessage
    id="shared.wasNotLoadedText"
    defaultMessage="was not loaded."
    description="The last part of the sentence 'Unit: 'Room 101' was not loaded'"
  />
);
export const noPermissionText = (
  <FormattedMessage
    id="shared.noPermissionText"
    defaultMessage="We're sorry, you don't have permission for this"
    description="The last part of the sentence 'Unit: 'Room 101' was not loaded'"
  />
);
export const noPermissionPageText = (
  <FormattedMessage
    id="shared.noPermissionPageText"
    defaultMessage="We're sorry, you don't have permission to view this page. Please use the navigation bar to visit another page."
    description="The last part of the sentence 'Unit: 'Room 101' was not loaded'"
  />
);

export const infoText = (
  <FormattedMessage
    id="shared.infoText"
    defaultMessage="Info"
    description="The type of the item"
  />
);
export const staffText = (
  <FormattedMessage
    id="shared.staffText"
    defaultMessage="Staff Profile"
    description="The type of the item"
  />
);
export const checkinText = (
  <FormattedMessage
    id="shared.checkinText"
    defaultMessage="Check-in Profile"
    description="The type of the item"
  />
);
export const maleText = (
  <FormattedMessage
    id="shared.maleText"
    defaultMessage="Male"
    description="The type of the item"
  />
);
export const femaleText = (
  <FormattedMessage
    id="shared.femaleText"
    defaultMessage="Female"
    description="The type of the item"
  />
);
export const itemText = (
  <FormattedMessage
    id="shared.itemText"
    defaultMessage="Item"
    description="The type of the item"
  />
);

export const lastCheckinText = (
  <FormattedMessage
    id="shared.lastCheckinText"
    defaultMessage="Last Check-In"
    description="The type of the item"
  />
);
export const staffAccessLevelsDescriptions = (
  <FormattedMessage
    id="shared.staffAccessLevelsDescriptions"
    defaultMessage="Access Levels increase in capability: {br}{br}Read Only: {br} Read only access to the main page. {br}{br}Staff Assignment Staff Member:{br}Can be assigned to areas within the staff assignment module. {br}{br}Basic Access:{br}Can send Quick Messages and Reminders, can confirm alarms on the main page. {br}{br}Reports:{br}Can run reports.{br}{br}Device Administration:{br}Can register, enroll and edit devices. {br}{br}System Administration:{br}Can update Modes and Actions.{br}{br}User Administration:{br}Can do anything within the system."
    values={{
      br: <br />,
    }}
    description="Text that displays when archiving a user to warn the user what will happen when the user is archived"
  />
);

export const battTypeText = (
  <FormattedMessage
    id="shared.battTypeText"
    defaultMessage="Battery Type"
    description="The type of the item"
  />
);

export const shutdownDeclarationText = (
  <FormattedMessage
    id="shared.shutdownDeclarationText"
    defaultMessage="Shutdown Declaration"
    description="The type of the item"
  />
);

export const firstBatteryLowText = (
  <FormattedMessage
    id="shared.firstBatteryLowText"
    defaultMessage="First Low Battery"
    description="The date when the device first report low battery"
  />
);

export const hl7ResidentIdText = (
  <FormattedMessage
    id="shared.hl7ResidentIdText"
    defaultMessage="Resident Id"
    description="Hl7 Resident Id"
  />
);

export const hl7VisitIdText = (
  <FormattedMessage
    id="shared.hl7VisitIdText"
    defaultMessage="Visit ID"
    description="Hl7 Visit Id"
  />
);

export const hl7VisitNameText = (
  <FormattedMessage
    id="shared.hl7VisitNameText"
    defaultMessage="Admit ID"
    description="Hl7 Visit Name"
  />
);